function isLocked(unlocked_at) {
    return unlocked_at !== null;
}

export function mergeWorldTours(world, tours) {
    const stopMap = new Map();
    for (const tour of tours) {
        for (const stop of tour.stops) {
            const id = stop.city.id;
            if (!stopMap.has(id)) {
                stopMap.set(id, {
                    latitude: stop.city.latitude,
                    longitude: stop.city.longitude,
                    speed: !!stop.speed,
                    clips: [],
                });
            }
            stopMap.get(id).clips.push(...stop.clips);
        }
    }

    return world.map((continent) => ({
        ...continent,
        countries: continent.countries
            .map((country) => ({
                ...country,
                cities: country.cities
                    .map((city) => {
                        const stop = stopMap.get(city.id);
                        if (!stop) return null;
                        return { ...city, ...stop };
                    })
                    .filter(Boolean),
            }))
            .filter((country) => country.cities.length > 0),
    }));
}

export function transformContinents(continents) {
    const pinnedCities = continents.flatMap((cont) =>
        cont.countries.flatMap((country) =>
            country.cities.map((city) => ({
                name: city.name,
                countryName: country.name,
                countryCode: country.code,
                lat: parseFloat(city.latitude),
                lng: parseFloat(city.longitude),
                continent: cont.code,
                locked: isLocked(city.unlocked_at),
                unlockDate: city.unlocked_at,
                description: city.description ?? null,
                speed: !!city.speed,
                clips: city.clips ?? [],
                activities: city.activities ?? [],
                flight_url: city.flight_url ?? null,
                guide_url: city.guide_url ?? null,
                guide_image: city.guide_image ?? null,
                visited: country.visited ?? 0,
            })),
        ),
    );

    const continentOrder = Object.fromEntries(
        continents.map((cont) => [
            cont.code,
            cont.countries.flatMap((c) => c.cities.map((city) => city.name)),
        ]),
    );

    const searchableCities = pinnedCities.map((c) => ({
        name: c.name,
        countryName: c.countryName,
        locked: c.locked,
        continent: c.continent,
    }));

    const continentLabels = Object.fromEntries(
        continents.map((cont) => [cont.code, cont.name]),
    );

    return { pinnedCities, continentOrder, searchableCities, continentLabels };
}
